import { IApplication } from '@/types'

export interface ApplicationSlice {
  selectedApplication: IApplication
  applicationStatus: string
  setSelectedApplication: (application: IApplication) => void
  setApplicationStatus: (status: string) => void
}

export const createApplicationSlice = (set: any): ApplicationSlice => ({
  selectedApplication: {} as IApplication,
  applicationStatus: '',
  setSelectedApplication: (application: IApplication) => set({ selectedApplication: application }),
  setApplicationStatus: (status: string) => set({ applicationStatus: status })
})
